define('recaptcha',['jquery'], function($)
{
    var $recatpchas = $('.g-recaptcha');
    if ($recatpchas.length == 0) return;

    window.init_recaptchas = function()
    {
        $recatpchas.each(function() {
            grecaptcha.render(this, {
                sitekey: $(this).data('sitekey')
            });
        });
    };

    var $html = $('html');
    $('body').append('<script src="https://www.google.com/recaptcha/api.js?hl=' + $html.attr('lang') + '&onload=init_recaptchas&render=explicit"></script>');
});
